export default __webpack_public_path__ + "static/media/luiksluitingA.jpg";